import i18n from '../../locales/index'
export function getSkuMeta (detail) {
  const result = {
    name: '',
    uniqIndex: null,
  };
  if (!detail.mall_properties || !detail.mall_properties.length) {
    result.uniqIndex = 'single';
  } else {
    const specs = detail.mall_properties.slice();
    specs.sort((a, b) => a.mall_property_name_id - b.mall_property_name_id);
    let id = '';
    let name = '';
    specs.forEach((spec, index) => {
      id += `${spec.mall_property_name_id}_${spec.mall_property_value_id}`;
      name += `${spec.mall_property_value_name}`;
      if (index + 1 < specs.length) {
        id += '__';
        name += ' ';
      }
    });
    result.name = name;
    result.uniqIndex = id;
  }
  return result;
}
